import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import styles from './styles.module.scss'

import { finishTimerList } from '../../../api'

import { ArrowIcon } from '../Attendance/icons'
import TimePicker from '../../Core/TimePicker'

const CrossIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        d="M.878 11.09 0 10.21l4.667-4.666L0 .878.878 0l4.667 4.667L10.21 0l.879.878-4.667 4.667 4.667 4.666-.879.879-4.666-4.667L.878 11.09Z"
      />
    </svg>
  )
}

export const ClockIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#1384FF"
        d="M10.006 20A10.066 10.066 0 0 0 20 9.999 10.073 10.073 0 0 0 9.993 0 10.063 10.063 0 0 0 0 9.999 10.075 10.075 0 0 0 10.006 20ZM4.96 11.109a.705.705 0 0 1-.712-.722.704.704 0 0 1 .712-.704h4.329V3.876a.704.704 0 0 1 .704-.709.704.704 0 0 1 .711.712v6.508a.703.703 0 0 1-.711.722H4.96Z"
      />
    </svg>
  )
}

const ClockoutModal = forwardRef(({companyId, onStop}, ref) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)
  const [employees, setEmployees] = useState([])
  const [clockOutTime, setClockOutTime] = useState(moment().format('HH:mm'))

  const timePickerRef = useRef(null)

  useImperativeHandle(ref, () => ({
    open: (employees) => {
      setEmployees(employees)
      setOpen(true)
    }
  }))

  const handleClose = () => {
    setOpen(false)
  }

  const handleChangeTime = (time) => {
    setClockOutTime(time)
  }

  const handleSubmit = async () => {
    const [employee] = employees
    const startTime = moment(employee.active_timer.started_at)
    const endTime = startTime.clone().hour(clockOutTime.split(':')[0]).minute(clockOutTime.split(':')[1])
    if (endTime.isBefore(startTime)) {
      endTime.add(1, 'day')
    }
    const post = {
      employeesArr: employees.map(emp => emp.id),
      custom_clock_out_time: endTime.format('YYYY-MM-DD HH:mm'),
    }
    const res = await finishTimerList(companyId, post)
    if (res) {
      onStop()
      handleClose()
    }
  }

  return (
    <Dialog onClose={() => handleClose(false)} maxWidth={'md'} open={open}>
      <div className={styles.container}>
        <div className={styles.header}>
          { t('Clock out {{count}} employees?', {count: employees.length}) }
          <div className={styles.closeButton} onClick={handleClose}>
            <CrossIcon />
          </div>
        </div>
        <div className={styles.employees}>
          <div className={styles.row}>
            <div>{ t('Employee') }</div>
            <div>{ t('Clocked-in') }</div>
          </div>
          <div className={styles.employeesList}>
            {
              employees.map(employee => {
                return (
                  <div key={employee.id} className={styles.row}>
                    <div>{ employee.name } { employee.surname }</div>
                    <div className={styles.times}>
                      { employee.active_timer.start } <ArrowIcon style={{transform: 'rotate(45deg)'}} color="#000" /> &nbsp;...
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.clockoutTime} onClick={() => timePickerRef.current.open()}>
            <div className={styles.clockoutTimeHeader}>
              <ClockIcon />
              { t('Clock out with this time') }
            </div>
            <div className={styles.time}>{clockOutTime}</div>
            <TimePicker ref={timePickerRef} onChange={handleChangeTime} />
          </div>
          <div style={{flex: 1}}>
            <div className={styles.clockoutButton} onClick={handleSubmit}>
              { t('Clock Out') }
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
})

export default ClockoutModal
